export const commandBarCommands = {
  open: 'command-bar.open',
};
